import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import Select from "react-select";
import { format, subWeeks, subMonths, subYears, startOfToday } from "date-fns";
import { toast } from "sonner";
import WorkItemOpen from "./WorkItemOpen";
import CustomLoader from "../static/CustomLoader";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const AllItem = ({ refresh, setRefresh }) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [loading, setLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [density, setDensity] = useState("standard");
  const [myWorkItemData, setmyWorkItemData] = useState([{}]);
  const [userData, setUserData] = useState([{}]);
  const [userCode, setUserCode] = useState("");
  const [editShow, setEditShow] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [dateRange, setDateRange] = useState("");
  const [assignedUserOptions, setAssignedUserOptions] = useState([]);
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");

  const editHandleClose = () => {
    setIsConfirmOpen(true);
  };

  const handleClose = () => {
    setEditShow(false);
  };

  const editHandleShow = () => {
    if (
      selectedRowData == null ||
      selectedRowData.length > 1 ||
      selectedRowData.length === 0
    ) {
      toast.warning("Please select only one value");
      return;
    }
    setEditShow(true);
  };

  const handleConfirmClose = () => {
    setIsConfirmOpen(false);
    setEditShow(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return format(new Date(dateString), "yyyy/MM/dd HH:mm:ss");
  };

  const getUserLebel = (assignedUserOptions, assigneCode) => {
    const assignee = assignedUserOptions.find(
      (option) => option.value === assigneCode,
    );
    const label = assignee ? assignee.label : assigneCode;
    return String(label);
  };

  const columns = [
    {
      field: "workid",
      headerName: "Permit No",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <span style={{ fontWeight: 700 }}>{params.value}</span>
      ),
    },
    {
      field: "statusval",
      headerName: "Status",
      width: 130,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "previoususer",
      headerName: "Previous User",
      width: 180,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => getUserLebel(assignedUserOptions, params.value),
    },
    {
      field: "createdatetime",
      headerName: "Created Date Time",
      width: 210,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => formatDate(params.value),
    },
    {
      field: "lastupdatedatetime",
      headerName: "Last Update Date Time",
      width: 220,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => formatDate(params.value),
    },
    {
      field: "expectedcompletiontime",
      headerName: "Expected Resolution Date Time",
      width: 240,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => formatDate(params.value),
    },
    {
      field: "assignedtime",
      headerName: "Assigned Time",
      width: 210,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => formatDate(params.value),
    },
  ];

  useEffect(() => {
    fetchUserData();
    fetchAllWorkitems();
    fetchUserOptions();
  }, [refresh]);

  const fetchUserData = async () => {
    setLoading(true);
    axios.get(apiUrl + "user", { headers }).then((response) => {
      if (response.data.cd === 1) {
        toast.info(response.data.description);
        setLoading(false);
      } else {
        const userOption = response.data.map((op) => ({
          value: op.empcode,
          label: op.userid,
        }));
        setUserData(userOption);
        setLoading(false);
      }
    });
  };

  const fetchUserOptions = async () => {
    try {
      const response = await axios.get(`${apiUrl}user/activeuser`, { headers });

      if (Array.isArray(response.data)) {
        const options = response.data.map((user) => ({
          value: user.empcode,
          label: user.userid,
        }));
        setAssignedUserOptions(options);
      } else {
        console.error("Unexpected response format.");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const clearAction = () => {
    setSDate("");
    setEDate("");
    setUserCode("");
    setDateRange("");
    fetchAllWorkitems();
  };

  const filterAction = async () => {
    const isUserFilter = !!userCode;
    const isDateFilter = !!sDate && !!eDate;

    if (!isUserFilter && !isDateFilter) {
      toast.error("Please provide at least one filter: User or Date Range");
      return;
    }

    if (isDateFilter && !sDate) {
      toast.error("Please Select Start Date");
      return;
    }

    if (isDateFilter && !eDate) {
      toast.error("Please Select End Date");
      return;
    }

    setLoading(true);
    setmyWorkItemData([]);

    try {
      const headers1 = {
        Authorization: `Bearer ${dbTokenData}`,
        "Content-Type": "application/json",
        dbMaster: "",
        from: sDate,
        to: eDate,
        createUser: userCode,
      };

      const response = await axios.get(`${apiUrl}worklist/filter/all`, {
        headers: headers1,
      });

      if (response.data.length === 0) {
        toast.info("Data not found");
        setmyWorkItemData([]);
      } else if (response.data.cd === 1) {
        toast.info(response.data.description);
      } else {
        setmyWorkItemData(response.data);
      }
    } catch (error) {
      console.error("Error during filterAction:", error);
      toast.error("An error occurred while fetching data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchAllWorkitems = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${apiUrl}worklist/all`, { headers });

      if (response.data.length === 0) {
        toast.info("Data not found");
        setmyWorkItemData([]);
      } else if (response.data.cd === 1) {
        toast.info(response.data.description);
      } else {
        setmyWorkItemData(response.data);
      }
    } catch (error) {
      console.error("Error during filterAction:", error);
      toast.error("An error occurred while fetching data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleUserChange = (selectedOption) => {
    if (selectedOption) {
      const selectedValue = selectedOption.value;
      setUserCode(selectedValue);
    } else {
      setUserCode("");
    }
  };

  const getOpenStatus = (params) => {
    const currentDate = new Date();
    const expectedDate = new Date(params.row.expectedcomdatetime);

    let workType = "";

    try {
      const commentData = JSON.parse(params.row.comment);

      if (commentData && commentData[0] && commentData[0].workType) {
        workType = commentData[0].workType;
      }
    } catch (error) {
      console.error("Error parsing comment data:", error);
    }

    const diffInMinutes = (expectedDate - currentDate) / (1000 * 60);

    if (params.row.wlid === selectedRowData?.wlid) {
      return "highlight-selected";
    }

    if (workType === "hotWork") {
      return "highlight-row-red";
    }

    if (workType === "coldWork") {
      return "highlight-row-blue";
    }

    if (diffInMinutes > 10) {
      return "highlight-row-new";
    }

    if (diffInMinutes <= 10 && diffInMinutes > 0) {
      return "highlight-row-less";
    }

    return "highlight-row-more";
  };

  const handleRowSelection = (selectedIds) => {
    const selectedRow = myWorkItemData.find(
      (row) => row.wlid === selectedIds[0],
    );

    setSelectedRowData(selectedRow || null);
  };

  const setDateFilter = (range) => {
    let startDate;
    let endDate = format(startOfToday(), "yyyy-MM-dd");

    switch (range) {
      case "lastWeek":
        startDate = format(subWeeks(startOfToday(), 1), "yyyy-MM-dd");
        break;

      case "lastMonth":
        startDate = format(subMonths(startOfToday(), 1), "yyyy-MM-dd");
        break;

      case "lastYear":
        startDate = format(subYears(startOfToday(), 1), "yyyy-MM-dd");
        break;

      default:
        startDate = "";
        endDate = "";
    }

    setSDate(startDate);
    setEDate(endDate);
    setDateRange(range);
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="outline"
                tooltip="Filter work items"
                onClick={filterAction}
                disabled={loading}
              >
                Filter
              </MasterButton>

              <MasterButton
                variant="danger"
                tooltip="Clear all filters"
                onClick={clearAction}
                disabled={loading}
              >
                Clear
              </MasterButton>

              <MasterButton
                variant="primary"
                tooltip="Open Selected Work Request"
                onClick={editHandleShow}
                disabled={loading}
              >
                Open
              </MasterButton>
            </>
          }
        />

        <Box
          sx={{
            px: 1.5,
            py: 1.25,
            backgroundColor: "#FFFFFF",
            borderBottom: "1px solid #E2E8F0",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2.5,
              flexWrap: "wrap",
              mb: 1.5,
            }}
          >
            {[
              {
                value: "lastWeek",
                label: "Last Week",
              },
              {
                value: "lastMonth",
                label: "Last Month",
              },
              {
                value: "lastYear",
                label: "Last Year",
              },
            ].map((item) => (
              <Box
                key={item.value}
                component="label"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                  cursor: "pointer",
                  userSelect: "none",
                  color: "#33485C",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                <Box
                  component="input"
                  type="radio"
                  name="dateRange"
                  checked={dateRange === item.value}
                  onChange={() => setDateFilter(item.value)}
                  sx={{
                    width: 16,
                    height: 16,
                    margin: 0,
                    accentColor: "#123B5D",
                  }}
                />
                {item.label}
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
                md: "1fr 1fr 1fr",
              },
              gap: 1.5,
              alignItems: "end",
            }}
          >
            <Box className="form-group">
              <label>Start Date</label>
              <input
                required
                value={sDate}
                onChange={(e) => setSDate(e.target.value)}
                onClick={(e) => e.target.showPicker?.()}
                className="form-control"
                type="date"
              />
            </Box>

            <Box className="form-group">
              <label>End Date</label>
              <input
                required
                value={eDate}
                onChange={(e) => setEDate(e.target.value)}
                onClick={(e) => e.target.showPicker?.()}
                className="form-control"
                type="date"
              />
            </Box>

            <Box className="form-group">
              <label>Created User</label>
              <Select
                value={
                  userCode
                    ? userData.find((option) => option.value === userCode)
                    : null
                }
                onChange={handleUserChange}
                placeholder="Select User"
                options={userData}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
            </Box>
          </Box>
        </Box>

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            myWorkItemData &&
            myWorkItemData.length > 0 &&
            Object.keys(myWorkItemData[0]).length !== 0
              ? myWorkItemData
              : []
          }
          columns={columns}
          onSelectionModelChange={handleRowSelection}
          getRowId={(row) => row.wlid}
          getRowClassName={getOpenStatus}
          sx={{
            "& .highlight-row-red": {
              backgroundColor: "#FF3B30",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#F52F24",
              },
              "& .MuiDataGrid-cell": {
                color: "#FFFFFF",
                borderColor: "rgba(255,255,255,0.45)",
              },
            },
            "& .highlight-row-blue": {
              backgroundColor: "#087FF5",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#0873DE",
              },
              "& .MuiDataGrid-cell": {
                color: "#FFFFFF",
                borderColor: "rgba(255,255,255,0.45)",
              },
            },
            "& .highlight-selected": {
              backgroundColor: "#E7F0FA",
              "&:hover": {
                backgroundColor: "#DCEAF7",
              },
              "& .MuiDataGrid-cell": {
                color: "#123B5D",
              },
            },
            "& .highlight-row-new": {
              backgroundColor: "#F2FBF6",
              "&:hover": {
                backgroundColor: "#E8F7EF",
              },
            },
            "& .highlight-row-less": {
              backgroundColor: "#FFF9E8",
              "&:hover": {
                backgroundColor: "#FFF3D1",
              },
            },
            "& .highlight-row-more": {
              backgroundColor: "#FFF0F3",
              "&:hover": {
                backgroundColor: "#FFE5EA",
              },
            },
          }}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Work Request"
        maxWidth="xl"
      >
        <WorkItemOpen
          selectedId={selectedRowData?.workid}
          selectedStep={selectedRowData?.stepcd}
          selectedWorklistId={selectedRowData?.wlid}
          selectedWorklistPUser={selectedRowData?.previoususer}
          onHide={handleClose}
          setRefresh={setRefresh}
          mode="A"
          fetchWorkItemData={fetchAllWorkitems}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={isConfirmOpen}
        title="Close Confirmation"
        message="Are you sure you want to close?"
        onConfirm={handleConfirmClose}
        onCancel={() => setIsConfirmOpen(false)}
      />
    </>
  );
};

export default AllItem;
